export const FamilyUserRelationship = {
    SON: 'son',
    DAUGHTER: 'daughter',
    FATHER: 'father',
    MOTHER: 'mother',
    HUSBAND: 'husband',
    WIFE: 'wife',
    BROTHER: 'brother',
    SISTER: 'sister',
    FRIEND: 'friend',
}
